import { API_BASE_URL, MEDIA_BASE_URL } from '../config/api';

/**
 * Resolve product image URL. Returns full URL for relative paths, or null if no image / placeholder.
 */
export const getProductImageUrl = (url) => {
  if (!url || typeof url !== 'string') return null;
  const u = url.trim();
  if (!u) return null;
  if (/placeholder/i.test(u)) return null;
  if (u.startsWith('http://') || u.startsWith('https://')) return u;
  if (u.startsWith('/api/') || u.startsWith('api/')) {
    return API_BASE_URL + (u.startsWith('/') ? u : '/' + u);
  }

  const mediaPath = u.replace(/^\/+/, '').replace(/^media\//i, '');
  const base = MEDIA_BASE_URL || '';
  return `${base}/media/${mediaPath}`;
};

export const formatCurrency = (amount, locale = 'en') => {
  const suffix = locale === 'ar' ? ' د.ع' : ' IQD';
  if (amount >= 1000000) return `${(amount / 1000000).toFixed(1)}M${suffix}`;
  if (amount >= 1000) return `${(amount / 1000).toFixed(0)}K${suffix}`;
  return `${amount.toFixed(0)}${suffix}`;
};

export const formatDate = (date, locale = 'en') => {
  if (!date) return '';
  const d = new Date(date);
  if (locale === 'ar') {
    return d.toLocaleDateString('ar-SA', { year: 'numeric', month: 'long', day: 'numeric' });
  }
  return d.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
};

export const formatDateTime = (date, locale = 'en') => {
  if (!date) return '';
  const d = new Date(date);
  if (locale === 'ar') {
    return d.toLocaleString('ar-SA');
  }
  return d.toLocaleString('en-US');
};

export const formatTimeAgo = (timestamp, locale = 'en') => {
  const timeSpan = new Date() - new Date(timestamp);
  const minutes = Math.floor(timeSpan / 60000);
  const hours = Math.floor(timeSpan / 3600000);
  const days = Math.floor(timeSpan / 86400000);

  if (locale === 'ar') {
    if (minutes < 1) return 'الآن';
    if (minutes < 60) return `منذ ${minutes} دقيقة`;
    if (hours < 24) return `منذ ${hours} ساعة`;
    return `منذ ${days} يوم`;
  }
  if (minutes < 1) return 'Just now';
  if (minutes < 60) return `${minutes}m ago`;
  if (hours < 24) return `${hours}h ago`;
  return `${days}d ago`;
};
